import { Button } from '@mui/material';
import React, { useEffect, useState } from 'react'
import Collapse from 'react-bootstrap/Collapse';
import { priceunit } from '../../Components/client-config';
import { useTranslation } from 'react-i18next';
import { formatPrice } from '../../utils/format-price';

export default function LastOrderDetail(props: any) {
    const { order_item } = props.orderData;
    const [orderItems, setOrderItems]: any = useState([])
    const [value, setValue] = useState(0);
    useEffect(() => {
        setOrderItems(order_item)
    }, [props.orderData])
    function handleCollpase(currentIndex: any) {
        orderItems[currentIndex].collapseIn = !orderItems[currentIndex].collapseIn;
        setOrderItems(orderItems)
        setValue(value + 1)
    }
    const { t } = useTranslation();

    return (
        <div>
            {orderItems?.map((item: any, index: any) => {
                return <>
                    <div className='order-added mt-3 mb-3'>
                        <div>
                            <h6>
                                {item?.item_name || item?.combo_name}
                                {item?.donation_id ? "Donation": ""} 
                                {" : "}
                                {item?.order_item_quantity}
                            </h6>
                            {(item.modifiers && JSON.parse(item.modifiers) && JSON.parse(item.modifiers).length > 0) &&
                                <Button
                                    onClick={() => handleCollpase(index)}
                                    aria-controls="example-fade-text"
                                    aria-expanded={item.collapseIn}
                                    className='bg-theme p-0 track-detail px-1 font-medium mt-1'
                                    variant="contained" color="error"
                                >{t("DETAILS")}<i className={!item.collapseIn ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line"}></i></Button>}
                        </div>
                        <h5>{priceunit} {formatPrice(item?.order_item_grossprice)}</h5>
                    </div>
                    <Collapse in={item.collapseIn}>
                        <div id="example-fade-text">
                            <div className="item-quantity collapse show" id="example-collapse-text" >
                                {item.modifiers && JSON.parse(item.modifiers) && JSON.parse(item.modifiers).length > 0 &&
                                    JSON.parse(item.modifiers).map((obj: any) => {
                                        return <div className="d-flex justify-content-between px-2">
                                            <li>{obj.modifier_name} x {obj.quantity}</li>
                                        </div>
                                    })
                                }
                            </div>
                        </div>
                    </Collapse>
                </>
            })}

        </div>
    )
}
